import { apiError } from '../../utils/errors';
import { getApiBaseUrl } from '../../utils/api-base-url';

export interface SubmitAdditionalThirdPartiesResponse {
  message: string;
  submissionStatus: string;
  createdThirdParties: number;
}

export const submitAdditionalThirdParties = async (
  urlSlug: string,
  publicId: string,
  responses: Record<string, unknown>,
  type?: string,
): Promise<SubmitAdditionalThirdPartiesResponse> => {
  const baseUrl = `${getApiBaseUrl()}/submissions/${urlSlug}/${publicId}/additional-third-parties`;
  const params = new URLSearchParams();
  if (type) params.append('type', type);
  const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      responses,
    }),
  });

  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to submit additional third parties', responseJson?.code);
  }

  return responseJson.data;
};
